import Ajv from "ajv";

import { lvtResponseSchema } from "../common";


const archiveCabinetInfoProperties = {
    id: { type: "number" },
    clientId: { type: "number" },
    clientName: { type: ["string", "null"] },
    locationName: { type: ["string", "null"] },
    liveUnitName: { type: ["string", "null"] },
    city: { type: ["string", "null"] },
    state: { type: ["string", "null"] },
    accessArchives: { type: "boolean" },
    showClientName: { type: "boolean" },
};

const archiveCabinetInfoSchema = {
    type: "object",
    additionalProperties: false,
    required: Object.keys(archiveCabinetInfoProperties),
    properties: archiveCabinetInfoProperties,
};

export const archiveCabinetInfoValidator = new Ajv().compile(archiveCabinetInfoSchema);

const lvtResponseArchiveCabinetInfoSchema = lvtResponseSchema(archiveCabinetInfoSchema);

export const lvtResponseArchiveCabinetInfoValidator = new Ajv().compile(lvtResponseArchiveCabinetInfoSchema);
